import React from 'react';
import { ButtonGroup } from 'framework-ui-components/Components/V2';
import AzioniCreaDomanda from './AzioniCreaDomanda';
import AltreAzioni from './AltreAzioni';
import StampaDichiarazioni from './StampaDichiarazioni';

const AzioniAssegnoNucleoFamiliare = (props) => (
  <ButtonGroup className="azioni-anf with-sub-menu">
    <StampaDichiarazioni {...props} primary />
    <AzioniCreaDomanda {...props} />
    <AltreAzioni {...props} />
  </ButtonGroup>
);

export default AzioniAssegnoNucleoFamiliare;
